export enum ChipStatusEnum {
  BLUE,
  RED,
  GREY,
}

const ChipStatusColors = {
  [ChipStatusEnum.BLUE]: {
    backgroundColor: "bg-blue-medium bg-opacity-10",
    fontColor: "text-blue-medium",
  },
  [ChipStatusEnum.RED]: {
    backgroundColor: "bg-red-common bg-opacity-10",
    fontColor: "text-[#FF0000]",
  },
  [ChipStatusEnum.GREY]: {
    backgroundColor: "bg-black bg-opacity-10",
    fontColor: "",
  },
};

interface ChipProps {
  status: ChipStatusEnum;
  text: string;
  className?: string;
  id?: string;
}

const Chip = ({ status, text, className, id }: ChipProps) => {
  const { backgroundColor, fontColor } = ChipStatusColors[status];

  return (
    <div
      id={id}
      className={`w-fit px-[8px] py-[2px] rounded-3xl flex items-center ${backgroundColor} ${className}`}
    >
      <span className={`text-xs font-medium ${fontColor}`}>{text}</span>
    </div>
  );
};

export default Chip;
